import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import PageCouponCategories from 'Pages/couponCategories';
import PageCouponCategory from 'Pages/couponCategory';

const Home = ({ match }) => (
	<div className="dashboard-wrapper">
		<Switch>
			<Redirect exact from={`${match.url}/`} to={`${match.url}/list`} />
			<Route exact path={`${match.url}/list`} component={PageCouponCategories} />
			<Route exact path={`${match.url}/create`} component={PageCouponCategory} />
			<Route exact path={`${match.url}/edit/:categoryId`} component={PageCouponCategory} />
			<Redirect to="/error" />
		</Switch>
	</div>
);
export default Home;
